import { WhatsappLogo } from "@phosphor-icons/react";
import { waLink } from "@/lib/site";

export default function WhatsAppButton() {
    return (
        <a
            href={waLink()}
            target="_blank"
            rel="noreferrer"
            data-testid="whatsapp-floating-button"
            aria-label="Chat with us on WhatsApp"
            className="fixed bottom-6 right-6 z-50 group"
        >
            <span className="flex items-center gap-3 bg-gold text-navy px-4 py-3 rounded-full animate-wa-pulse shadow-lg transition-all duration-300 group-hover:bg-[#E5C158]">
                <WhatsappLogo size={24} weight="fill" />
                <span className="hidden sm:inline font-sans text-xs uppercase tracking-widest font-semibold">
                    Chat on WhatsApp
                </span>
            </span>
        </a>
    );
}
